import { categories } from '@/mocks/categories';

export default function Footer() {
  const linkColumns = [
    {
      title: 'Categorie',
      links: categories.slice(0, 6).map((c) => ({ label: c.name, url: c.url })),
    },
    {
      title: 'Risorse',
      links: [
        { label: 'Guida Completa', url: '/articoli/guida-completa' },
        { label: 'Sicurezza', url: '/articoli/sicurezza' },
        { label: 'Prodotti', url: '/articoli/prodotti' },
        { label: 'Come Usare', url: '/articoli/come-usare' },
      ],
    },
    {
      title: 'Link Utili',
      links: [
        { label: 'itaobuy sheet', url: 'https://kaspreadsheet.com' },
        { label: 'buy it now', url: 'https://kaspreadsheet.com' },
        { label: 'Home', url: '/' },
        { label: 'FAQ', url: '/#faq' },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-3">
            <a href="/" className="inline-flex items-center gap-2 mb-4">
              <span className="font-heading text-xl font-semibold text-background-50">
                Itaobuy<span className="text-accent-400">Spread</span>
              </span>
            </a>
            <p className="text-background-300 text-sm leading-relaxed mb-6">
              La guida italiana completa per Itaobuy Spreadsheet. Scopri prodotti, tutorial e consigli per navigare in modo più sicuro ed efficiente.
            </p>
          </div>

          {linkColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="text-background-50 font-semibold text-sm mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.url.startsWith('http') ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-background-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a
                        href={link.url}
                        className="text-background-400 hover:text-accent-400 text-sm transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <h4 className="text-background-50 font-semibold text-sm mb-4">Newsletter</h4>
            <p className="text-background-400 text-sm mb-4">Ricevi aggiornamenti e nuovi contenuti su Itaobuy Spreadsheet.</p>
            <form
              className="flex flex-col sm:flex-row gap-2"
              data-readdy-form
              action="https://readdy.ai/api/form/d9b14ocngs93pt5sh6sg"
              method="POST"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypotEl = form.querySelector<HTMLInputElement>('[name="company_alt"]');
                if (honeypotEl && honeypotEl.value.trim() !== '') {
                  const msg = form.querySelector<HTMLElement>('.form-message');
                  if (msg) msg.textContent = 'Iscrizione completata!';
                  return;
                }
                const formData = new FormData(form);
                fetch(form.action, { method: 'POST', body: formData })
                  .then(async (res) => {
                    const text = await res.text();
                    let parsed;
                    try { parsed = JSON.parse(text); } catch { parsed = null; }
                    const msg = form.querySelector<HTMLElement>('.form-message');
                    if (res.ok && parsed?.code === 'OK') {
                      if (msg) { msg.textContent = 'Grazie! Ti sei iscritto con successo.'; msg.className = 'form-message text-accent-400 text-xs mt-2'; }
                      form.reset();
                    } else {
                      if (msg) { msg.textContent = parsed?.meta?.message || 'Errore, riprova più tardi.'; msg.className = 'form-message text-red-400 text-xs mt-2'; }
                    }
                  })
                  .catch(() => {
                    const msg = form.querySelector<HTMLElement>('.form-message');
                    if (msg) { msg.textContent = 'Errore di connessione, riprova.'; msg.className = 'form-message text-red-400 text-xs mt-2'; }
                  });
              }}
            >
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <input
                type="email"
                name="email"
                placeholder="La tua email"
                required
                className="flex-1 px-4 py-2.5 rounded-lg bg-foreground-800 border border-foreground-700 text-background-100 text-sm placeholder:text-background-500 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="px-5 py-2.5 rounded-lg bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
              >
                Iscriviti
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
              <p className="form-message text-xs mt-1 col-span-full"></p>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} Itaobuy Spread Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-background-500 hover:text-background-300 text-xs transition-colors">Privacy</a>
            <a href="/" className="text-background-500 hover:text-background-300 text-xs transition-colors">Cookie</a>
            <a href="/" className="text-background-500 hover:text-background-300 text-xs transition-colors">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}